import {
  selectPayWithCreditCard,
  selectPayWithPaypal
} from 'reduxModules/checkout'
import {
  cardTypeChanged,
  toggleStorePaymentAction,
  saveTokenizer,
  paymentMethodFieldBecameValid
} from './'

export const dispatchCardTypeChanged = (dispatch, cards) =>
  dispatch(cardTypeChanged(cards.length === 1 ? cards[0].type : ''))

export default (dispatch) => ({
  cardTypeChanged: ({ cards }) => dispatchCardTypeChanged(dispatch, cards),
  toggleStorePayment: () => dispatch(toggleStorePaymentAction()),
  storeTokenizer: (tokenize) => dispatch(saveTokenizer(tokenize)),
  fieldBecameValid: (field) => dispatch(paymentMethodFieldBecameValid(field)),
  choosePayWithCreditCard: () => dispatch(selectPayWithCreditCard()),
  choosePayWithPaypal: () => dispatch(selectPayWithPaypal())
})
